<script setup lang="ts">
import { onMounted } from 'vue'

import MenuList from '../../../components/menu/MenuList.vue'
import SeoHeadline from '../../../components/page-footer/SeoHeadline.vue'
import NewsletterSubscription from '../../../components/shared/NewsletterSubscription.vue'
import SocialLinks from '../../../components/shared/SocialLinks.vue'
import FooterAboTeaser from './FooterAboTeaser.vue'
import AiNotice from '../../../components/content-footer/AiNotice.vue'

import type { ComposedPage } from '@xcel-next/composer-schema'

defineProps<{
  footerData?: ComposedPage['footer']
}>()

onMounted(() => {
  const headline = document.querySelector('[data-menu-group-headline=pur-abo]')
  if (headline) headline.textContent = 'Mein Lecker'
})
</script>

<template>
  <div class="bx-flooding bx-flooding--footer">
    <footer class="bx-footer bx-typo--footer">
      <div class="bx-footer__wrapper">
        <div class="bx-grid">
          <NewsletterSubscription usage="footer"
                                  headline="Täglich frische Rezepte entdecken"
                                  kicker="Zum kostenlosen Newsletter" />
          <SeoHeadline />
          <FooterAboTeaser />
          <SocialLinks menu-type="footer" />
        </div>
      </div>
      <div class="bx-footer__menu">
        <div class="bx-grid">
          <MenuList :menu="footerData?.menu"
                    menu-type="footer" />
          <AiNotice />
        </div>
      </div>
    </footer>
  </div>
</template>
